import React, { useEffect, useState } from 'react';
import { Icon, Table, TableColumnOpcoes, TableSearch } from '@components';
import { deleteBloqueio, getBloqueios } from '@ducks/conectoresBloqueios';
import { useDispatch, useSelector } from 'react-redux';

export default function TableBloqueios() {
  const dispatch = useDispatch();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const bloqueios = useSelector(({ conectoresBloqueios }) => conectoresBloqueios.get('bloqueios').toArray());
  const loadingBloqueios = useSelector(({ conectoresBloqueios }) => conectoresBloqueios.get('loadingBloqueios'));
  const successDeleteBloqueio = useSelector(({ conectoresBloqueios }) => conectoresBloqueios.get('successDeleteBloqueio'));

  const handleSearch = () => {
    return dispatch(getBloqueios());
  };

  useEffect(() => {
    handleSearch();
  }, []);

  useEffect(() => {
    if (successDeleteBloqueio) handleSearch();
  }, [successDeleteBloqueio]);

  const excluirBloqueio = (conectorIdentify) => {
    dispatch(deleteBloqueio(conectorIdentify));
  };

  const columns = [
    {
      title: 'Cliente',
      dataIndex: 'nmCliente',
      key: 'nmCliente',
      ...TableSearch('nmCliente', 'cliente', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Conector',
      dataIndex: 'conectorIdentify',
      key: 'conectorIdentify',
      ...TableSearch('conectorIdentify', 'conector', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '20%',
      render: (text, item) => (
        <TableColumnOpcoes>
          <Icon.Delete
            type='desbloqueio'
            customIcon={Icon.UnlockOutlined}
            hoverColor='#ffffff'
            hoverBgColor='#28a745'
            tooltipTitle='Desbloquear conector'
            popConfirmTitle={`Deseja desbloquear o conector ${item.conectorIdentify}?`}
            action={() => excluirBloqueio(item.conectorIdentify)}
          />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey='id' columns={columns} dataSource={bloqueios} loading={loadingBloqueios} hidePagination />;
}
